"use strict";

import $ from "jquery";

export default function fixed(scope) {
    $(scope).each(function () {
        const offset = $(".header__main").offset();

        $(window).scroll(() => {
            const winTop = $(window).scrollTop();
            if (winTop > offset.top) {
                $(this).addClass("header--fixed");
            } else {
                $(this).removeClass("header--fixed");
            }
        });
    });
}
